import React, { lazy, Suspense } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Layout from "./Layout";
import Home from "./Home";
import ErrorPage from "./ErrorPage";
import CatalogueShimmer from "./CatalogueShimmer";
import Shimmer from "./Shimmer";
import ContactShimmer from "./ContactShimmer";

// ✅ Lazy-load with background prefetch
const Collection = lazy(() =>
  import(/* webpackPrefetch: true */ "./Collection")
);

const Catalogue = lazy(() =>
  import(/* webpackPrefetch: true */ "./Catalogue")
);

const Contact = lazy(() =>
  import(/* webpackPrefetch: true */ "./Contact")
);

const Body = () => {
  const appRouter = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      errorElement: <ErrorPage />,
      children: [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/collection",
          element: (
            <Suspense fallback={<Shimmer/>}>
              <Collection />
            </Suspense>
          ),
        },
        {
          path: "/catalogue",
          element: (
            <Suspense fallback={<CatalogueShimmer/>}>
              <Catalogue />
            </Suspense>
          ),
        },
        {
          path: "/contact",
          element: (
            <Suspense fallback={<ContactShimmer/>}>
              <Contact />
            </Suspense>
          ),
        },
      ],
    },
  ]);

  return <RouterProvider router={appRouter} />;
};

export default Body;
